export const PAYMENT_DETAIL_STORAGE = "payment_detail";
export const ACCESS_TOKEN_STORAGE = "access_token";
export const EXPIRES_AT_STORAGE = "expires_at";
export const USERNAME_STORAGE = "username";
export const USER_STORAGE = "user";



// WEBPACK FOOTER //
// ./src/constants/storageConst.js